import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-e-toll-disable-modal',
  templateUrl: './e-toll-disable-modal.component.html',
  styleUrls: ['./e-toll-disable-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ETollDisableModalComponent {

  constructor(
    public dialogRef: MatDialogRef<ETollDisableModalComponent>
  ) { }

}
